import React, { useState } from 'react';
import CodeSentIcon from '../Assets/SVG/codeSentIcon';
import TextInput from '../../../Shared/TextInput/TextInput';
import Footer from '../Assets/footer';

const FourDigitEntry = (props) => {
  const [fourDigits, setFourDigits] = useState('');
  const [errorInForm, setErrorForm] = useState(null);

  const validateDigits = async () => {
    if (fourDigits == '') {
      setErrorForm('אנא הזן 4 ספרות אחרונות');
      return false;
    }
    let isRightCode = await props.onclick(fourDigits);

    if (!isRightCode) {
      setErrorForm('המספר שהקלדתם לא תואם את זה שיש אצלנו, שננסה שוב?');
    }
  };
  return (
    <div className='screenContainer'>
      <form action="#" onSubmit={async (e) => {
        e.preventDefault();
        await validateDigits();
      }}>
        <CodeSentIcon />
        <h3 className='heading withSecondary'>מהן 4 הספרות האחרונות​ של אמצעי התשלום?</h3>
        <h3 className='secondaryHeading'>רק רוצים לוודא שאתם זה אתם :)<br />ולא אף אחד אחר</h3>
        <TextInput
          placeholder={'4 ספרות אחרונות'}
          value={fourDigits}
          error={errorInForm}
          maxLength={'4'}
          type="text"
          inputMode="numeric"
          onChange={(e) => {
            const numberRegex = /^\d+$/;
            if ((numberRegex.test(e.target.value) || e.target.value === '') && e.target?.value?.length <= 9) {
              setFourDigits(e.target.value);
              setErrorForm(null);
            }

          }}
        />
        <Footer onclick={(() => { })} stage={props.stage} />

      </form>
    </div>
  );
};

export default FourDigitEntry;
